/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 */
import { api } from '../../../config/api';

import type { BookingRules, UpdateSettingsBookingRulesApiArg } from '../types';

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    updateSettingsBookingRules: build.mutation<BookingRules, UpdateSettingsBookingRulesApiArg>({
      query: (queryArg) => ({
        body: queryArg.body,
        method: 'PATCH',
        url: `/v1/settings/booking`,
      }),
    }),
  }),
  overrideExisting: true,
});

export { injectedRtkApi as updateSettingsBookingRulesApi };
export const { useUpdateSettingsBookingRulesMutation } = injectedRtkApi;
